/* eslint-disable prefer-const */
import { useEffect, useState } from "react";
import { OrderingForSaleProps } from "./detailsOrder.props";
import { Position } from "../../../../interfaces/ordering/sale/position";
import PhoneInput, { CountryData } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ru from "react-phone-input-2/lang/ru.json";
import { PaymentService } from "../../../../services/payment.service";
import { OrderingForSaleService } from "../../../../services/orderingForSale.service";
import { CreatePaymentInternetAcquiringOnParameters } from "../../../../interfaces/ordering/payment/createPaymentInternetAcquiringOnParameters";
import { InternetAcquiringEnum } from "../../../../interfaces/ordering/crm/internetAcquiringEnum";
import Router from "next/router";
import { ParametersForGetAccount } from "../../../../interfaces/ordering/payment/parametersForGetAccount";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Formik } from "formik";
import * as yup from "yup";
import _ from "lodash";
import { Card } from "react-bootstrap";
import { CreateParameters } from "../../../../interfaces/tinkoff/createParameters";
import { OrderingParametersForCreate } from "../../../../interfaces/ordering/orderingParametersForCreate";
import { TinkoffService } from "../../../../services/tinkoff.service";
import Spinners from "../../../spinner/spinner";
import { ConfigServer } from "../../../../configs/config.server";
import { PaymentType } from "../../../../interfaces/enum/paymentType";
import { InstallmentPlanTinkoff } from "../../../../interfaces/ordering/installmentPlanTinkoff";
import { InstallmentTinkoff } from "../../../../interfaces/tinkoff/installmentTinkoff";

const letters = /^[A-Za-zа-яёА-ЯЁ -]+$/i;
const regEmail =
  /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Схема валидации зависит от isNewClient: для нового клиента телефон обязателен, иначе — нет
const getSchema = (isNewClient: boolean) =>
  yup.object().shape({
    firstName: yup
      .string()
      .matches(letters, "Имя должно содержать только символы алфавита")
      .required("Заполните поле Имя")
      .min(1)
      .max(30, "Имя не может превышать 30 символов"),
    lastName: yup
      .string()
      .matches(letters, "Фамилия должна содержать только символы алфавита")
      .required("Заполните поле Фамилия")
      .min(1)
      .max(30, "Фамилия не может превышать 30 символов"),
    email: yup
      .string()
      .matches(regEmail, "Введите правильно email: you@yourdomain.com")
      .required("Заполните поле Email")
      .email("Введите правильно email: you@yourdomain.com"),
  });

interface IState {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  paymentInstallments: number;
  isLoading: boolean;
  paymentType: PaymentType;
  installmentTinkoff: InstallmentTinkoff;
  accountPaymentForTinkoff: string | null;
}

const style = {
  borderTopWidth: "0px",
  borderRightWidth: "0px",
  borderLeftWidth: "0px",
  borderRadius: "0px",
  fontSize: "1rem",
  width: "100%",
  "&:focus": {
    boxShadow: "0 0 0 0rem rgba(0,123,255,0.25)",
  },
};

export const DetailsOrder = (props: OrderingForSaleProps): JSX.Element => {
  // Создаем начальное состояние на основе переданных данных
  const createInitialState = (): IState => {
    const initialState: IState = {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      paymentInstallments: 0,
      isLoading: false,
      paymentType: PaymentType.PayByCard,
      installmentTinkoff: {
        value: 0,
        month: 3,
        name: "Installment00345",
        tBankValue: "installment_0_0_3_4,5",
        description: "",
      },
      accountPaymentForTinkoff: null,
    };

    // Заполняем данные клиента, если они есть
    if (props.orderingForSale && props.orderingForSale.customer) {
      initialState.firstName = props.orderingForSale.customer.firstName || "";
      initialState.lastName = props.orderingForSale.customer.lastName || "";
      initialState.email = props.orderingForSale.customer.email || "";

      const customerPhone = props.orderingForSale.customer.phone ?? null;

      if (props.isNewClient) {
        // Новый клиент — телефон НЕ подставляем
        initialState.phone = "";
      } else if (customerPhone === 0 || customerPhone === null) {
        // Не новый клиент — если нет телефона, подставляем дефолт
        initialState.phone = "79161111111";
      } else {
        // Не новый клиент — если телефон есть, используем его
        initialState.phone = String(customerPhone);
      }
    }

    // Расчет рассрочки, если есть сумма заказа
    if (props.orderingForSale && props.orderingForSale.totalSum > 0) {
      const installmentTinkoff = _.find(
        props.installmentTinkoffList,
        function (o) {
          let installmentPlanTinkoffs =
            InstallmentPlanTinkoff[props.orderingForSale.installmentPlanTinkoff];

          if (installmentPlanTinkoffs) {
            return (
              o.name ===
              InstallmentPlanTinkoff[
              props.orderingForSale.installmentPlanTinkoff
              ]
            );
          }

          if (props.orderingForSale.installmentPlanTinkoff) {
            return (
              o.tBankValue ===
              props.orderingForSale.installmentPlanTinkoff.toString()
            );
          }

          return (
            o.name ===
            InstallmentPlanTinkoff[InstallmentPlanTinkoff.Installment00345]
          );
        }
      );

      if (installmentTinkoff) {
        initialState.installmentTinkoff = installmentTinkoff;
      }

      const tl: number = props.orderingForSale.totalSum;

      const installment: number = Math.ceil(
        tl / initialState.installmentTinkoff.month
      );

      initialState.paymentInstallments = installment;
    }

    return initialState;
  };

  // Создаем начальное состояние один раз при инициализации компонента
  const formInitialValues = createInitialState();

  // Используем типизированный useState
  const [state, setState] = useState<IState>(formInitialValues);
  const { paymentInstallments, isLoading, paymentType, accountPaymentForTinkoff } = state;

  const config = ConfigServer(props.hostName);

  useEffect(() => {
    const fetchData = async () => {
      let accountPaymentForTinkoff =
        await OrderingForSaleService.getPaymentAccountForTinkoffInstallment(
          config.ServiceOrdering.GetPaymentAccountForTinkoffInstallment,
          null,
          props.orderingForSale.partnerId
        );

      if (
        props.orderingForSale.totalSum > 3142 &&
        props.orderingForSale.totalSum < 523560
      ) {
        setState((prevState) => ({
          ...prevState,
          accountPaymentForTinkoff: accountPaymentForTinkoff,
        }));
      } else {
        console.info(
          "Сумма заказа должна быть не менее 3142 и не более 523560 руб. для ТБанк."
        );
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const payTinkoff = async (model: IState) => {
    setState((prevState) => ({ ...prevState, isLoading: true }));

    if (props.preOrderingId && !props.orderingForSale.orderingId) {
      let result = await createOrdering(model);

      let resultRequest = await createRequestTinkoff(result!);

      if (!resultRequest.isError) {
        Router.push(resultRequest.url);
      }
    } else {
      let resultRequest = await createRequestTinkoff(
        props.orderingForSale.orderingId!
      );

      if (!resultRequest.isError) {
        Router.push(resultRequest.url);
      }
    }
  };

  const pay = async (model: IState) => {
    setState((prevState) => ({ ...prevState, isLoading: true }));

    // Проверяем была ли ранее создана заявка в интернет-эквайринге, если да — перенаправляем
    if (props.orderingForSale.orderingId) {
      const url =
        await OrderingForSaleService.getPayUrlInternetAcquiringOnOrderingV2(
          props.orderingForSale.orderingId,
          InternetAcquiringEnum.Payler,
          config.ServiceOrdering.GetPayUrlInternetAcquiringOnOrderingV2
        );

      if (url) {
        Router.push(url);
      }
    }

    if (props.orderingForSale && props.orderingForSale.customer) {
      props.orderingForSale.customer.email = model.email;
      props.orderingForSale.customer.firstName = model.firstName;
      props.orderingForSale.customer.lastName = model.lastName;

      if (props.isNewClient) {
        // Телефон берём из формы ТОЛЬКО для нового клиента
        const digits = (model.phone || "").match(/\d+/g) ?? [];
        const phoneNum = parseInt(digits.join(""), 10);
        if (!Number.isNaN(phoneNum)) {
          props.orderingForSale.customer.phone = phoneNum;
        }
      }
      // Иначе — не трогаем существующий телефон
    }

    if (props.preOrderingId && !props.orderingForSale.orderingId) {
      let resultOrdering = await createOrdering(model);

      props.orderingForSale.orderingId = resultOrdering ?? "";
    }

    let param: ParametersForGetAccount = {
      partnerId: props.orderingForSale.partnerId,
      webSitesShortName: config.WebSitesName,
    };

    let accountList = await PaymentService.getAccountsOnParameters(
      param,
      config.ServiceOrdering.GetAccountsOnParameters
    );

    let accountNumber = accountList.filter((item) => {
      return item.isDefault === true;
    })[0].accountNumber;

    let parameters: CreatePaymentInternetAcquiringOnParameters = {
      accountNumber: accountNumber,
      internetAcquiring: InternetAcquiringEnum.Payler,
      orderingId: props.orderingForSale.orderingId,
      webSiteName: config.WebSitesName,
      isMobile: false,
    };

    const result =
      await PaymentService.createPaymentInternetAcquiringOnParametersOrdering(
        parameters,
        config.ServiceOrdering.CreatePaymentInternetAcquiringOnParametersOrdering
      );

    if (!result.isError && result.urlPay) {
      Router.push(result.urlPay);
    }
  };

  const createOrdering = async (model: IState) => {
    if (
      props.orderingForSale.orderingId === null ||
      props.orderingForSale.orderingId === undefined
    ) {
      // Проверяем, что props.ordering существует перед его использованием
      if (props.ordering) {
        const phoneForOrder = props.isNewClient
          ? +((model.phone || "").replace(/[^0-9]/g, ""))
          : Number(props.orderingForSale?.customer?.phone ?? 79161111111);

        props.ordering.customer = {
          email: model.email,
          firstName: model.firstName,
          lastName: model.lastName,
          phone: phoneForOrder,
          pin: null,
          bitrixId: null,
          contactId: null,
        };

        if (props.ordering.campaignNumber === "") {
          props.ordering.campaignNumber = null;
        }
      }

      let orderingParametersForCreate: OrderingParametersForCreate = {
        googleAnalytics: null,
        preOrderingId: props.preOrderingId,
        ordering: props.ordering,
      };

      let result = await PaymentService.createOrderingV2(
        orderingParametersForCreate,
        config.ServiceOrdering.CreateOrderingV2
      );

      if (!result.isError) {
        return result.orderingId;
      }
    }

    return null;
  };

  const createDemoRequestTinkoff = async (orderingId: string) => {
    let createParameters: CreateParameters = {
      isTest: false,
      accountPayment: accountPaymentForTinkoff,
      webSitesName: config.WebSitesName,
      orderingId: orderingId,
    };

    let result = await TinkoffService.createDemo(
      createParameters,
      config.ServiceInternetAcquiring.CreateDemo
    );

    return result;
  };

  const createRequestTinkoff = async (orderingId: string) => {
    let createParameters: CreateParameters = {
      isTest: false,
      accountPayment: accountPaymentForTinkoff!,
      webSitesName: config.WebSitesName,
      orderingId: orderingId,
    };

    let result = await TinkoffService.create(
      createParameters,
      config.ServiceInternetAcquiring.Create
    );

    return result;
  };

  return (
    <>
      <Spinners isActive={isLoading} />
      {props.orderingForSale && (
        <>
          <Row>
            <Col md={12} lg={12} xl={12} xxl={12} className="order-info-block">
              {props.orderingForSale.orderNumber ? (
                <p className="bb" data-qa-locator="text-order-number">
                  Ваш заказ № {props.orderingForSale.orderNumber}:
                </p>
              ) : (
                <p className="bb" data-qa-locator="text-order-number">
                  Ваш заказ:
                </p>
              )}

              <div data-qa-locator="text-position-name-list">
                {props.orderingForSale.positionList.map(
                  (position: Position, index: number) => {
                    return <p key={index}>{position.productName}</p>;
                  }
                )}
              </div>

              {props.orderingForSale.recurrentInfo && (
                <p className="order-info-block-description">
                  Сумма оплаты по заказу:{" "}
                  {props.orderingForSale.recurrentInfo.amountFirstPayment.toLocaleString(
                    "ru"
                  )}
                  &nbsp;
                  <i
                    className="fa-solid fa-ruble-sign"
                    style={{ fontSize: "0.85em" }}
                  ></i>
                </p>
              )}
              {props.orderingForSale.prePaymentAmount &&
                props.orderingForSale.prePaymentAmount > 0 && (
                  <p className="order-info-block-description">
                    Сумма по заказу:{" "}
                    {props.orderingForSale.totalSum.toLocaleString("ru")}&nbsp;
                    <i
                      className="fa-solid fa-ruble-sign"
                      style={{ fontSize: "0.85em" }}
                    ></i>
                  </p>
                )}
            </Col>
          </Row>

          <Card>
            <Card.Body>
              <Formik
                validationSchema={getSchema(!!props.isNewClient)}
                onSubmit={(values: IState) => {
                  switch (paymentType) {
                    case PaymentType.PayByCard:
                      pay(values);
                      break;
                    case PaymentType.Tinkoff:
                      payTinkoff(values);
                      break;
                    default:
                      pay(values);
                      break;
                  }
                }}
                initialValues={formInitialValues}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  errors,
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Form.Group
                        as={Col}
                        md={7}
                        lg={7}
                        xl={7}
                        xxl={7}
                        controlId="validationFormik01"
                        className="form-floating"
                      >
                        <Form.Control
                          type="text"
                          name="firstName"
                          value={values.firstName}
                          onChange={handleChange}
                          isValid={touched.firstName && !errors.firstName}
                          isInvalid={!!errors.firstName}
                          data-qa-locator="input-firstName"
                        />
                        <Form.Label>Имя</Form.Label>
                        <Form.Control.Feedback type="invalid">
                          {errors.firstName}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>

                    <Row className="mb-3">
                      <Form.Group
                        as={Col}
                        md={7}
                        lg={7}
                        xl={7}
                        xxl={7}
                        controlId="validationFormik02"
                        className="form-floating"
                      >
                        <Form.Control
                          type="text"
                          name="lastName"
                          value={values.lastName}
                          onChange={handleChange}
                          isValid={touched.lastName && !errors.lastName}
                          isInvalid={!!errors.lastName}
                          data-qa-locator="input-lastName"
                        />
                        <Form.Label>Фамилия</Form.Label>
                        <Form.Control.Feedback type="invalid">
                          {errors.lastName}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>

                    <Row className="mb-3">
                      <Form.Group
                        as={Col}
                        md={7}
                        lg={7}
                        xl={7}
                        xxl={7}
                        controlId="validationFormik03"
                        className="form-floating"
                      >
                        <Form.Control
                          type="text"
                          name="email"
                          data-qa-locator="input-email"
                          value={values.email}
                          onChange={handleChange}
                          isValid={touched.email && !errors.email}
                          isInvalid={!!errors.email}
                        />
                        <Form.Label>Email</Form.Label>
                        <Form.Control.Feedback type="invalid">
                          {errors.email}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>

                    {props.isNewClient && (
                      <Row className="mb-3">
                        <Form.Group
                          as={Col}
                          md={7}
                          lg={7}
                          xl={7}
                          xxl={7}
                          controlId="validationFormik04"
                          className="form-floating"
                        >
                          <PhoneInput
                            country={"ru"}
                            localization={ru}
                            preferredCountries={["ru", "kz", "ua"]}
                            value={values.phone}
                            inputProps={{
                              name: "phone",
                            }}
                            onChange={(phoneNumber, country, e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            inputStyle={style}
                            isValid={(
                              inputNumber: string,
                              country: CountryData
                            ) => {
                              const format = country.format || "";
                              const countNumberInPhone = [...format].filter(
                                (x) => x === "."
                              ).length;
                              const phoneLength = inputNumber.length;

                              if (phoneLength !== countNumberInPhone) {
                                (errors as any).phone =
                                  "Номер телефона заполнен не корректно.";
                              } else {
                                delete (errors as any).phone;
                              }

                              return phoneLength === countNumberInPhone;
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Номер телефона заполнен не корректно.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>
                    )}

                    <div
                      className="card-footer confirm-btn-wrap"
                      style={{ borderTopWidth: "0px", marginTop: "0px" }}
                    >
                      <Row className="mb-3">
                        <Col
                          md={12}
                          lg={12}
                          xl={12}
                          xxl={12}
                          style={{ fontSize: "20px" }}
                        >
                          Всего к оплате:
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col
                          md={6}
                          lg={6}
                          xl={6}
                          xxl={6}
                          className="order-total"
                        >
                          <span
                            data-qa-locator="total-sum"
                            className="text-span-price"
                          >
                            {props.orderingForSale.totalSum.toLocaleString(
                              "ru"
                            )}
                            &nbsp;<i className="fa-solid fa-ruble-sign" />
                          </span>
                          <Row className="mb-3" style={{ paddingBottom: "7%" }}>
                            <Col md={12} lg={12} xl={12} xxl={12}>
                              <span className="text-span-gray">
                                оплата всей стоимости заказа
                              </span>
                            </Col>
                          </Row>
                        </Col>

                        <Col md={6} lg={6} xl={6} xxl={6}>
                          <div className="d-grid gap-2 col-8">
                            <button
                              className="btn btn-danger"
                              onClick={() => {
                                setState((prevState) => ({
                                  ...prevState,
                                  paymentType: PaymentType.PayByCard,
                                }));
                              }}
                              data-qa-locator="btn-pay-total-sum"
                              type="submit"
                              data-bs-toggle="button"
                              style={{ fontSize: "18px" }}
                            >
                              Оплатить{" "}
                              {props.orderingForSale.totalSum.toLocaleString(
                                "ru"
                              )}
                              &nbsp;
                              <i
                                className="fa-solid fa-ruble-sign"
                                style={{ fontSize: "16px" }}
                              ></i>
                            </button>
                          </div>
                        </Col>
                      </Row>

                      {accountPaymentForTinkoff && (
                        <Row className="mb-3">
                          <Col md={6} className="order-total">
                            <span
                              data-qa-locator="payment-installments-sum"
                              className="text-span-price"
                            >
                              {paymentInstallments.toLocaleString("ru")}&nbsp;
                              <i className="fa-solid fa-ruble-sign"></i>/мес.
                            </span>
                            <Row className="mb-3" style={{ paddingBottom: "7%" }}>
                              <Col md={12}>
                                <span className="text-span-gray">
                                  оплата частями
                                </span>
                              </Col>
                            </Row>
                          </Col>

                          <Col md={6} lg={6} xl={6} xxl={6}>
                            <div className="d-grid gap-2 col-8">
                              <button
                                className="btn btn-primary"
                                onClick={() => {
                                  setState((prevState) => ({
                                    ...prevState,
                                    paymentType: PaymentType.Tinkoff,
                                  }));
                                }}
                                data-qa-locator="btn-payment-installments"
                                type="submit"
                                data-bs-toggle="button"
                                style={{ fontSize: "18px" }}
                              >
                                Оплатить{" "}
                                {paymentInstallments.toLocaleString("ru")}&nbsp;
                                <i
                                  className="fa-solid fa-ruble-sign"
                                  style={{ fontSize: "16px" }}
                                />
                              </button>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </>
      )}
    </>
  );
};
